import publicLiveStreamsApi from '../api/publicLiveStreamsApi';

class PublicLiveStreamsService {
  getPublicLiveStreams(params) {
    return publicLiveStreamsApi.getPublicLiveStreams(params);
  }

  createPublicLiveStream(params) {
    return publicLiveStreamsApi.createPublicLiveStream(params).then(res => {
      if (!res.success) {
        return res;
      }
      return { success: true, data: res.data.items };
    });
  }
}

export default new PublicLiveStreamsService();
